import reservationWx from '@/views/WX/reservation_wx'
import autoLoginWx from '@/views/WX/autoLogin'
export default [
  /* -------------- 微信相关页面 ----------- */
  {
    path:'/wx/needSignList',
    name:'needSignList',
    component: () => import( '@/views/School/Sign/needSignList'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path:'/wx/selfExtraReviewList',
    name:'selfExtraReviewList',
    component: () => import( '@/views/School/Sign/selfList'),
    meta: {
      label: '个人申请记录（补卡）',
      singlePage: true, // 不在Main中显示
    }
  },
  {
    path:'/wx/firstExtraReviewList',
    name:'firstExtraReviewList',
    component: () => import( '@/views/School/Sign/firstReview'),
    meta: {
      label: '二级单位审核（补卡）',
      singlePage: true, // 不在Main中显示
    }
  },
  {
    path:'/wx/secondExtraReviewList',
    name:'secondExtraReviewList',
    component: () => import( '@/views/School/Sign/secondReview'),
    meta: {
      label: '人事处审核（补卡）',
      singlePage: true, // 不在Main中显示
    }
  },
  {
    path:'/wx/hospitalExtraReviewList',
    name:'hospitalExtraReviewList',
    component: () => import( '@/views/School/Sign/hospitalReview'),
    meta: {
      label: '校医院审核（补卡）',
      singlePage: true, // 不在Main中显示
    }
  },
  {
    path:'/wx/signApplyDetail',
    name:'signApplyDetail',
    component: () => import( '@/views/School/Sign/applyDetailBox'),
    meta: {
      label: '补卡申请详情',
      singlePage: true, // 不在Main中显示
    }
  },
  {
    path: '/wx/validate',
    name: 'validate',
    component: () => import('@/views/WX/validate'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/wx/tempValidate',
    name: 'tempValidate',
    component: () => import('@/views/WX/tmpSelfSign/tempValidate'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/wx/tempSelfSign',
    name: 'tempSelfSign',
    component: () => import('@/views/WX/tmpSelfSign/tempSelfSign'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/wx/tempSelfSignRecord',
    name: 'tempSelfSignRecord',
    component: () => import('@/views/WX/tmpSelfSign/tempSelfSignRecord'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/wx/parse',
    name: 'parse',
    component: () => import('@/views/WX/parse'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/wx/login',
    name: 'login',
    component: () => import('@/views/WX/login'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/wx/autoLogin',
    name: '_autoLogin.vue',
    component: autoLoginWx,
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/wx/genQrcode',
    name: 'qrcode_gen',
    component: () => import('@/views/WX/qrcode'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/wx/vehicle-bind',
    name: 'VehicleBindWX',
    component: () => import('@/views/WX/vehicleBindWX'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/wx/reservation',
    name: 'reservation_wx',
    component: () => import('@/views/WX/reservation_wx'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/wx/personReservation',
    name: 'personReservation_wx',
    component: () => import( '@/views/WX/personReservation'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/wx/selfServiceReservation',
    name: 'selfServiceReservation',
    component: () => import( '@/views/WX/selfServiceReservation'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/wx/vehicleSelfReservation',
    name: 'vehicleSelfReservation',
    component: () => import( '@/views/WX/vehicleSelfReservation'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    name: 'PersonalCenterWX',
    component: () => import('@/views/WX/personalCenterWX'),
    path: '/wx/personal-center',
    meta: {
      singlePage: true,
      noLoginRequired: true, // 无需登录即可进入
    },
  },
  {
    name: 'PersonalReservationListWX',
    component: () => import('@/views/WX/personalReservationList'),
    path: '/wx/reservation/person',
    meta: {
      singlePage: true,
      noLoginRequired: true, // 无需登录即可进入
    },
  },
  {
    name: 'PersonalReservationDetailsWX',
    component: () => import('@/views/WX/reservationDetails'),
    path: '/wx/reservation/:plate/readonly',
    props: true,
    meta: {
      singlePage: true,
      noLoginRequired: true, // 无需登录即可进入
    },
  },
  {
    name: 'ViolationEventSubmitWX',
    component: () => import('@/views/WX/violationEventSubmit'),
    path: '/wx/event/submit',
    meta: {
      singlePage: true,
      noLoginRequired: true, // 无需登录即可进入
    },
  },
  {
    name: 'ViolationEventListWX',
    component: () => import('@/views/WX/violationList'),
    path: '/wx/event/list',
    meta: {
      singlePage: true,
      noLoginRequired: true, // 无需登录即可进入
    },
  },
  {
    name: 'ViolationEventDetailsWX',
    component: () => import('@/views/WX/violationEventDetails'),
    path: '/wx/event/:plate/readonly',
    props: true,
    meta: {
      singlePage: true,
      noLoginRequired: true, // 无需登录即可进入
    },
  },
  {
    name: 'MyVehicleListWX',
    component: () => import('@/views/WX/myVehicleList'),
    path: '/wx/my-vehicle-list',
    props: true,
    meta: {
      singlePage: true,
      noLoginRequired: true, // 无需登录即可进入
    },
  },
  {
    name: 'VehicleDetailsWX',
    component: () => import('@/views/WX/vehicleDetails'),
    path: '/wx/vehicle/:plate',
    props: true,
    meta: {
      singlePage: true,
      noLoginRequired: true, // 无需登录即可进入
    },
  },
  {
    name: 'SearchVehicle_wx',
    component: () => import('@/views/WX/searchVehicle'),
    path: '/wx/searchVehicle',
    props: true,
    meta: {
      singlePage: true,
      noLoginRequired: true, // 无需登录即可进入
    },
  },
  {
    name: 'billDetailsWx',
    component: () => import('@/views/WX/billDetails_wx'),
    path: '/wx/billDetails',
    props: true,
    meta: {
      singlePage: true,
      noLoginRequired: true, // 无需登录即可进入
    },
  },
  {
    name: 'purseDetail_wx',
    component: () => import('@/views/WX/purseDetail'),
    path: '/wx/purseDetail',
    props: true,
    meta: {
      singlePage: true,
      noLoginRequired: true, // 无需登录即可进入
    },
  },
  {
    name: 'purseUseDetail_wx',
    component: () => import('@/views/WX/purseUseDetail'),
    path: '/wx/purseUseDetail',
    props: true,
    meta: {
      singlePage: true,
      noLoginRequired: true, // 无需登录即可进入
    },
  },
  {
    name: 'searchBill',
    component: () => import('@/views/WX/searchBill_wx'),
    path: '/wx/searchBill',
    props: true,
    meta: {
      singlePage: true,
      noLoginRequired: true, // 无需登录即可进入
    },
  },
  {
    name: 'personPassRule_wx',
    component: () => import('@/views/WX/personPassRule'),
    path: '/wx/personPassRule',
    props: true,
    meta: {
      singlePage: true,
      noLoginRequired: true, // 无需登录即可进入
    },
  },
]

